import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { LogLevel } from "./ILogger";
import { TransferFormat } from "./ITransport";
import { Arg, getDataDetail, getUserAgentHeader, Platform, sendMessage } from "./Utils";
/** @private */

export var ServerSentEventsTransport = /*#__PURE__*/function () {
  function ServerSentEventsTransport(httpClient, accessTokenFactory, logger, options) {
    _classCallCheck(this, ServerSentEventsTransport);

    this._httpClient = httpClient;
    this._accessTokenFactory = accessTokenFactory;
    this._logger = logger;
    this._options = options;
    this.onreceive = null;
    this.onclose = null;
  }

  _createClass(ServerSentEventsTransport, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, transferFormat) {
        var _this = this;

        var token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Arg.isRequired(url, "url");
                Arg.isRequired(transferFormat, "transferFormat");
                Arg.isIn(transferFormat, TransferFormat, "transferFormat");

                this._logger.log(LogLevel.Trace, "(SSE transport) Connecting."); // set url before accessTokenFactory because this.url is only for send and we set the auth header instead of the query string for send


                this._url = url;

                if (!this._accessTokenFactory) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return this._accessTokenFactory();

              case 8:
                token = _context.sent;

                if (token) {
                  url += (url.indexOf("?") < 0 ? "?" : "&") + "access_token=".concat(encodeURIComponent(token));
                }

              case 10:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var opened = false;

                  if (transferFormat !== TransferFormat.Text) {
                    reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                    return;
                  }

                  var eventSource;

                  if (Platform.isBrowser || Platform.isWebWorker) {
                    eventSource = new _this._options.EventSource(url, {
                      withCredentials: _this._options.withCredentials
                    });
                  } else {
                    // Non-browser passes cookies via the dictionary
                    var cookies = _this._httpClient.getCookieString(url);

                    var headers = {};
                    headers.Cookie = cookies;

                    var _getUserAgentHeader = getUserAgentHeader(),
                        _getUserAgentHeader2 = _slicedToArray(_getUserAgentHeader, 2),
                        name = _getUserAgentHeader2[0],
                        value = _getUserAgentHeader2[1];

                    headers[name] = value;
                    eventSource = new _this._options.EventSource(url, {
                      withCredentials: _this._options.withCredentials,
                      headers: _objectSpread(_objectSpread({}, headers), _this._options.headers)
                    });
                  }

                  try {
                    eventSource.onmessage = function (e) {
                      if (_this.onreceive) {
                        try {
                          _this._logger.log(LogLevel.Trace, "(SSE transport) data received. ".concat(getDataDetail(e.data, _this._options.logMessageContent), "."));

                          _this.onreceive(e.data);
                        } catch (error) {
                          _this._close(error);

                          return;
                        }
                      }
                    }; // @ts-ignore: not using event on purpose


                    // @ts-ignore: not using event on purpose
                    eventSource.onerror = function (e) {
                      // EventSource doesn't give any useful information about server side closes.
                      if (opened) {
                        _this._close();
                      } else {
                        reject(new Error("EventSource failed to connect. The connection could not be found on the server," + " either the connection ID is not present on the server, or a proxy is refusing/buffering the connection." + " If you have multiple servers check that sticky sessions are enabled."));
                      }
                    };

                    eventSource.onopen = function () {
                      _this._logger.log(LogLevel.Information, "SSE connected to ".concat(_this._url));

                      _this._eventSource = eventSource;
                      opened = true;
                      resolve();
                    };
                  } catch (e) {
                    reject(e);
                    return;
                  }
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect(_x, _x2) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._eventSource) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", Promise.reject(new Error("Cannot send until the transport is connected")));

              case 2:
                return _context2.abrupt("return", sendMessage(this._logger, "SSE", this._httpClient, this._url, this._accessTokenFactory, data, this._options));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function send(_x3) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "stop",
    value: function stop() {
      this._close();

      return Promise.resolve();
    }
  }, {
    key: "_close",
    value: function _close(e) {
      if (this._eventSource) {
        this._eventSource.close();

        this._eventSource = undefined;

        if (this.onclose) {
          this.onclose(e);
        }
      }
    }
  }]);

  return ServerSentEventsTransport;
}();